/**
 * Independent source-of-truth bindings for an EDITORIAL_STORY spread.
 *
 * The Media Library owns the binary; a material's block references its chosen
 * media ID and optional portable URL. This deliberately never deletes or
 * clones a Media Library record. Revisions/snapshots are managed by backend.
 */
export function initialStoryImage(content = {}) {
  const c = content || {};
  const listed = Array.isArray(c.media_ids)
    ? c.media_ids.find((id) => typeof id === "string" && id.trim()) || null
    : null;
  // An explicit Owner-selected slot wins over a stale legacy array.
  const mediaId = (typeof c.hero_media_id === "string" && c.hero_media_id.trim())
    ? c.hero_media_id : listed;
  const mediaUrl = mediaId && mediaId === c.hero_media_id
    ? (c.hero_url || null) : null;
  return { mediaId, mediaUrl };
}

/**
 * Keep the selected photo independent of the editable source and paragraphs.
 * Removing the photo clears references only in THIS spread. It does not delete
 * the shared Media Library asset or affect any other material.
 */
export function saveStoryContent({ original = {}, sourceText = "", recognized = null,
                                   mediaId = null, mediaUrl = null }) {
  const c = original || {};
  const chosenId = typeof mediaId === "string" && mediaId.trim() ? mediaId : null;
  const chosenUrl = chosenId && typeof mediaUrl === "string" && mediaUrl.trim()
    ? mediaUrl : null;
  // Clearing the raw source is an explicit text removal. Do not resurrect
  // old frozen paragraphs on Save while leaving the independent photo intact.
  const clearingText = recognized === null && !String(sourceText).trim();
  const structured = recognized
    ? {
        eyebrow: recognized.eyebrow ?? c.eyebrow ?? "",
        headline: recognized.headline,
        subtitle: recognized.subtitle,
        lead: recognized.lead,
        quote: recognized.quote,
      }
    : clearingText
      ? { eyebrow: "", headline: "", subtitle: "", lead: "", quote: "" }
      : {};
  return {
    ...c,
    ...structured,
    body: sourceText,
    hero_media_id: chosenId,
    hero_url: chosenUrl,
    media_ids: chosenId ? [chosenId] : [],
    hero_mobile_media_id: null,
    hero_mobile_url: null,
    extra: {
      ...(c.extra || {}),
      editorial_story_source_text: sourceText,
      ...(recognized ? { paragraphs: recognized.paragraphs }
        : clearingText ? { paragraphs: [] } : {}),
    },
  };
}
